/**
 * CFleet Dispatcher - ReconnectingBanner
 *
 * Non-destructive "reconnecting" indicator. Renders nothing by default; shows a
 * thin banner at the top of the viewport while a token refresh is retrying after
 * a transient failure (`isReconnecting` from useAuth). Replaces the old behavior
 * where a single network blip during refresh bounced the user to /login — the
 * session is preserved while we retry with backoff.
 */

import React from 'react';
import { useAuth } from '@cfleet/auth';

const ReconnectingBanner: React.FC = () => {
  const { isReconnecting } = useAuth();

  if (!isReconnecting) return null;

  return (
    <div
      role="status"
      aria-live="polite"
      data-testid="reconnecting-banner"
      className="fixed top-0 inset-x-0 z-[9998] flex items-center justify-center gap-2 px-4 py-1.5 bg-amber-50 border-b border-amber-200 text-amber-800 text-xs font-medium"
    >
      <span className="inline-block h-3 w-3 animate-spin rounded-full border-2 border-amber-400 border-t-transparent" />
      <span>Reconnecting…</span>
    </div>
  );
};

export default ReconnectingBanner;
